import { render, staticRenderFns } from "./Threat.vue?vue&type=template&id=5edcf568&scoped=true&"
import script from "./Threat.vue?vue&type=script&lang=js&"
export * from "./Threat.vue?vue&type=script&lang=js&"
import style0 from "./Threat.vue?vue&type=style&index=0&id=5edcf568&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edcf568",
  null
  
)

export default component.exports